import Products from 'pages/Settings/Products/shared/components/Products'
import { flourProductsAdapter } from 'pages/Settings/Products/shared/adapters/flour'

export const FlourProductsPage = () => {
  return <Products adapter={flourProductsAdapter} />
}
